export default "__VITE_ASSET__BqLtmcE___"